<template>
  <!-- ========================= -->
  <!-- TAB: ADJUSTMENTS          -->
  <!-- ========================= -->
  <div>
    <!-- -------------- -->
    <!--     ROW 1      -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2">
      <!-- ---------------------------- -->
      <!--  characteristic adjs (r/o)   -->
      <!-- ---------------------------- -->
      <p class="bb-hdg mt-2 mb-3">Adjustments</p>
      <p class="bb-sub-hdg mt-3 mb-3">Characteristic Adjustments</p>
      <component
        style="display: block"
        :is="hasTooltip(item_characteristic_adj_reasons) ? 'ToolTip' : 'div'"
        v-bind="
          hasTooltip(item_characteristic_adj_reasons)
            ? { text: item_characteristic_adj_reasons, position: 'top' }
            : {}
        "
      >
        <div class="form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control"
              :value="item_characteristic_adj_reasons || 'None'"
              id="item_characteristic_adj_reasons"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="item_characteristic_adj_reasons"
            >
              Adjs
              <span
                v-if="hasTooltip(item_characteristic_adj_reasons)"
                class="bb-orange-circle"
              ></span>
            </label>
          </div>
        </div>
      </component>
    </div>
    <!-- -------------- -->
    <!--     ROW 2      -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2">
      <!-- --------------------- -->
      <!--  ability adjs (r/o)   -->
      <!-- --------------------- -->
      <p class="bb-sub-hdg mb-3 mt-2">Ability Adjustments</p>
      <component
        style="display: block"
        :is="hasTooltip(item_ability_adj_reasons) ? 'ToolTip' : 'div'"
        v-bind="
          hasTooltip(item_ability_adj_reasons)
            ? { text: item_ability_adj_reasons, position: 'top' }
            : {}
        "
      >
        <div class="form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control"
              :value="item_ability_adj_reasons || 'None'"
              id="item_ability_adj_reasons"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="item_ability_adj_reasons"
            >
              Adjs
              <span
                v-if="hasTooltip(item_ability_adj_reasons)"
                class="bb-orange-circle"
              ></span>
            </label>
          </div>
        </div>
      </component>
    </div>
    <!-- -------------- -->
    <!--     ROW 3      -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2">
      <p class="bb-sub-hdg mb-3 mt-2">Characteristic Skill Adjustments</p>
      <component
        style="display: block"
        :is="
          hasTooltip(item_characteristic_skill_adj_reasons) ? 'ToolTip' : 'div'
        "
        v-bind="
          hasTooltip(item_characteristic_skill_adj_reasons)
            ? { text: item_characteristic_skill_adj_reasons, position: 'top' }
            : {}
        "
      >
        <div class="form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control"
              :value="item_characteristic_skill_adj_reasons || 'None'"
              id="item_characteristic_skill_adj_reasons"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="item_characteristic_skill_adj_reasons"
            >
              Adjs
              <span
                v-if="hasTooltip(item_characteristic_skill_adj_reasons)"
                class="bb-orange-circle"
              ></span>
            </label>
          </div>
        </div>
      </component>
    </div>
    <!-- -------------- -->
    <!--     ROW 4      -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2">
      <!-- ---------------------------- -->
      <!--   applied skill adjs (r/o)   -->
      <!-- ---------------------------- -->
      <p class="bb-sub-hdg mb-3 mt-2">Applied Skill Adjustments</p>
      <component
        style="display: block"
        :is="hasTooltip(item_skill_adj_reasons_applied) ? 'ToolTip' : 'div'"
        v-bind="
          hasTooltip(item_skill_adj_reasons_applied)
            ? { text: item_skill_adj_reasons_applied, position: 'top' }
            : {}
        "
      >
        <div class="form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control"
              :value="item_skill_adj_reasons_applied || 'None'"
              id="item_skill_adj_reasons_applied"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="item_skill_adj_reasons_applied"
            >
              Adjs
              <span
                v-if="hasTooltip(item_skill_adj_reasons_applied)"
                class="bb-orange-circle"
              ></span>
            </label>
          </div>
        </div>
      </component>
    </div>
    <!-- -------------- -->
    <!--     ROW 5      -->
    <!-- -------------- -->
    <div class="row mt-3 mb-2">
      <!-- ---------------------------- -->
      <!--   optional skill adjs (r/o)  -->
      <!-- ---------------------------- -->
      <p class="bb-sub-hdg mb-2 mt-2">Optional Skill Adjustments</p>
      <component
        style="display: block"
        :is="hasTooltip(item_skill_adj_reasons_optional) ? 'ToolTip' : 'div'"
        v-bind="
          hasTooltip(item_skill_adj_reasons_optional)
            ? { text: item_skill_adj_reasons_optional, position: 'top' }
            : {}
        "
      >
        <div class="form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control"
              :value="item_skill_adj_reasons_optional || 'None'"
              id="item_skill_adj_reasons_optional"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="item_skill_adj_reasons_optional"
            >
              Adjs
              <span
                v-if="hasTooltip(item_skill_adj_reasons_optional)"
                class="bb-orange-circle"
              ></span>
            </label>
          </div>
        </div>
      </component>
    </div>
  </div>
</template>

<script>
import ToolTip from '../components/ToolTip.vue'

export default {
  name: 'ItemAdjustmentsTab',
  components: {
    ToolTip,
  },
  props: {
    item_characteristic_adj_reasons: {
      type: String,
      required: true,
    },
    item_ability_adj_reasons: {
      type: String,
      required: true,
    },
    item_characteristic_skill_adj_reasons: {
      type: String,
      required: true,
    },
    item_skill_adj_reasons_applied: {
      type: String,
      required: true,
    },
    item_skill_adj_reasons_optional: {
      type: String,
      required: true,
    },
  },
  methods: {
    hasTooltip(value) {
      return !!value && value !== 'None'
    },
  },
}
</script>
